import { render } from "./prenotazioniDetail.vue?vue&type=template&id=61e6962a&ts=true"
import script from "./prenotazioniDetail.vue?vue&type=script&lang=ts"
export * from "./prenotazioniDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__